import { render, staticRenderFns } from "./DataSetCardList.vue?vue&type=template&id=0ec89989&scoped=true"
import script from "./DataSetCardList.vue?vue&type=script&lang=js"
export * from "./DataSetCardList.vue?vue&type=script&lang=js"
import style0 from "./DataSetCardList.vue?vue&type=style&index=0&id=0ec89989&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec89989",
  null
  
)

export default component.exports